<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-2">
          <v-card-title>
            <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.promotion_code }}</td>
                <td>{{ dataDetail.item.promotion_name }}</td>
                <td>{{ format_number(dataDetail.item.quantity) }}</td>
                <td>
                  <div v-if="dataDetail.item.switch_disabled !== true">{{ diff_dateTH(dataDetail.item.end_date) }}</div>
                  <div v-else style="color: red">{{ diff_dateTH(dataDetail.item.end_date) }}</div>
                </td>
                <td><v-switch @click="update_status(dataDetail.item.id, dataDetail.item.status)" color="#86bc3a" v-model="dataDetail.item.status" :disabled="dataDetail.item.switch_disabled"></v-switch></td>
                <td class="pa-3">
                  <v-btn small height="42" @click="getDetails(dataDetail.item.id)" class="grad-success-bg white--text mr-1 mb-1">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {diffDateTH, formatNumber} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_product_exp",
  data() {
    return {
      multiLine: true,
      loading_page: false,
      alert_success: false,
      alert_danger: false,
      date_now: null,
      search: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'รหัสโปรโมชั่น',
          value: 'promotion_code',
          fixed: true,
          width: '100px',
        },
        {
          text: 'ชื่อ',
          value: 'promotion_name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'คงเหลือ',
          value: 'quantity',
          fixed: true,
          width: '150px',
        },
        {
          text: 'วันที่สิ้นสุด',
          value: 'end_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          fixed: true,
          width: '100px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '120px',
        },
      ],
      data_list: [],
    }
  },
  methods: {
    get_date() {
      let date_today = new Date();
      let day = date_today.getDate();
      let month = date_today.getMonth() + 1;
      let year = date_today.getFullYear();
      if (month < 10){
        month = '0'+ month
      }
      if (day < 10){
        day = '0'+ day
      }
      let date = year + '-' + month + '-' + day
      this.date_now = Date.parse(date)
    },
    get_data() {
      this.loading_page = true
      this.data_list = []
      HTTP.post('/inventory/promotions/expireds/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              res.data.object.forEach((data) => {
                let date_res = Date.parse(data.end_date)
                this.data_list.push({
                  created_at: data.created_at,
                  end_date: data.end_date,
                  id: data.id,
                  is_delete: data.is_delete,
                  note: data.note,
                  price_per_set: data.price_per_set,
                  promotion_code: data.promotion_code,
                  promotion_name: data.promotion_name,
                  quantity: data.quantity,
                  status: this.date_now > date_res ? 0 : data.status,
                  updated_at: data.updated_at,
                  user_id: data.user_id,
                  user_name: data.user_name,
                  switch_disabled: this.date_now > date_res ? true : false,
                })
              })
              this.data_list.sort((a, b) => {
                return parseFloat(b.status) - parseFloat(a.status);
              })
            }
          })
    },
    diff_dateTH: function (value) {
      return diffDateTH(value)
    },
    format_number: function (value) {
      return formatNumber(value)
    },
    getDetails(id) {
      this.$router.push('/stock/promotion_stock/promotiondetails/' + id);
    },
    update_status(id, status) {
      HTTP.post('/inventory/promotions/expireds/status', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 3000);
        }
      })
    }
  },
  mounted() {
    this.get_date()
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
</style>
